var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgKey = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.473 4.353l-.946-.94.946-.94a.67.67 0 10-.946-.946L6.5 8.553a3.333 3.333 0 10.947.947L10.7 6.24l.94.947a.666.666 0 00.473.193.666.666 0 00.474-1.14l-.947-.907.947-.946.94.946a.667.667 0 00.473.194.667.667 0 00.473-.194.666.666 0 000-.98zm-9.806 8.98a2 2 0 110-4 2 2 0 010 4z",
  fill: "#44494D"
})));
export default __webpack_public_path__ + "static/key.[git-hash].svg";
export { SvgKey as ReactComponent };